import { birthDayOf } from '../../../../utils/birthDay'

type DatedEvent = { startDateTime: string }

/** The day of the year ('MM-DD') an event comes back on, whatever its year. */
export const yearlyKey = (startDateTime: string): string => birthDayOf(startDateTime).slice(5)

export const isLeap = (year: number): boolean =>
  (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0

/** The events of each day of the year ('MM-DD'), for the dots of a calendar of birthdays. */
export const buildEventsByYearDay = <T extends DatedEvent>(events: T[]): Record<string, T[]> => {
  const byKey: Record<string, T[]> = {}
  for (const event of events) {
    const key = yearlyKey(event.startDateTime)
    byKey[key] = [...(byKey[key] || []), event]
  }
  return byKey
}

/**
 * The events of one day of one year. The people of 29 February are on
 * 28 February in the years without one, as in the list and the reminders.
 */
export const eventsOfYearDay = <T>(
  byKey: Record<string, T[]>,
  monthDay: string,
  year: number,
): T[] => [
  ...(byKey[monthDay] || []),
  ...(monthDay === '02-28' && !isLeap(year) ? byKey['02-29'] || [] : []),
]

/** The same, for every day of that year that has an event ('YYYY-MM-DD'). */
export const eventsOfYear = <T>(byKey: Record<string, T[]>, year: number): Record<string, T[]> => {
  const byDate: Record<string, T[]> = {}
  for (const monthDay of Object.keys(byKey)) {
    const shown = monthDay === '02-29' && !isLeap(year) ? '02-28' : monthDay
    byDate[`${year}-${shown}`] = eventsOfYearDay(byKey, shown, year)
  }
  return byDate
}
